/* eslint-disable class-methods-use-this */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { Portal } from 'react-portal';
import _ from 'lodash';

import { getActiveDimensions } from '@shared/active_resize_listener/selectors';
import { DIMENSION_STATES } from '../../utils/dimension';

import './fixed_footer.scss';

class FixedFooter extends Component {
  constructor(props) {
    super(props);

    this.getComponentNode = this.getComponentNode.bind(this);
  }

  componentDidMount() {
    document.body.classList.add('fixed-footer__wrapper');
  }

  componentWillUnmount() {
    document.body.classList.remove('fixed-footer__wrapper');
  }

  getComponentNode() {
    const isModalOpen = document.body.classList.contains('modal-open');
    const portalID = isModalOpen ? 'fixed-footer-modal' : 'fixed-footer';
    const elementId = document.getElementById(portalID);

    if (isModalOpen && elementId) {
      const modals = document && document.getElementsByClassName('slide-in__modal');
      return _.last(modals);
    }
    return elementId;
  }

  render() {
    const { children, classNameContainer, isMobile } = this.props;
    const isModalOpen = document.body.classList.contains('modal-open');

    return children ? (
      <Portal node={this.getComponentNode()}>
        <div
          className={classnames('fixed-footer', classNameContainer, {
            'fixed-footer--modal': isModalOpen,
            'fixed-footer--mobile': isMobile,
          })}
        >
          {children}
        </div>
      </Portal>
    ) : null;
  }
}

FixedFooter.propTypes = {
  classNameContainer: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.string,
  ]),
  isMobile: PropTypes.bool.isRequired,
};

FixedFooter.defaultProps = {
  children: null,
};
const mapStateToProps = state => ({
  isMobile: getActiveDimensions(state).state === DIMENSION_STATES.MOBILE,
});

export default connect(mapStateToProps)(FixedFooter);
